import { useEffect, useState } from 'react'

type QtyStepperProps = {
  value: number
  min?: number
  max?: number
  onChange: (qty: number) => void
  disabled?: boolean
}

/** Mirror superoti-kitchen/src/shared/components/QtyStepper.tsx. */
export function QtyStepper({ value, min = 0, max, onChange, disabled = false }: QtyStepperProps) {
  const [text, setText] = useState(String(value))

  useEffect(() => {
    setText(String(value))
  }, [value])

  const atMin = value <= min
  const atMax = max !== undefined && value >= max

  function commit(raw: string) {
    const trimmed = raw.trim()
    if (trimmed === '') {
      onChange(min)
      setText(String(min))
      return
    }
    const parsed = Number.parseFloat(trimmed)
    if (Number.isNaN(parsed)) {
      setText(String(value))
      return
    }
    let next = Math.max(min, parsed)
    if (max !== undefined) next = Math.min(max, next)
    onChange(next)
    setText(String(next))
  }

  return (
    <div className="inline-flex items-center gap-1 rounded-lg border border-outline-variant bg-surface p-1">
      <button
        type="button"
        disabled={disabled || atMin}
        onClick={() => onChange(Math.max(min, value - 1))}
        className="flex h-11 w-11 items-center justify-center rounded-md text-on-surface-variant hover:bg-surface-container disabled:opacity-40"
        aria-label="Kurangi jumlah"
      >
        <span className="material-symbols-outlined">remove</span>
      </button>
      <input
        type="text"
        inputMode="decimal"
        value={text}
        disabled={disabled}
        onChange={(e) => setText(e.target.value.replace(/[^0-9.]/g, ''))}
        onBlur={() => commit(text)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.currentTarget.blur()
          }
        }}
        aria-label="Jumlah"
        className="min-w-[3.5rem] max-w-[5rem] h-11 text-center text-body-lg font-bold tabular-nums bg-transparent border-0 outline-none focus:ring-2 focus:ring-primary/30 rounded-md disabled:opacity-40"
      />
      <button
        type="button"
        disabled={disabled || atMax}
        onClick={() => onChange(max !== undefined ? Math.min(max, value + 1) : value + 1)}
        className="flex h-11 w-11 items-center justify-center rounded-md text-on-surface-variant hover:bg-surface-container disabled:opacity-40"
        aria-label="Tambah jumlah"
      >
        <span className="material-symbols-outlined">add</span>
      </button>
    </div>
  )
}
